import React from "react";
import { Modal } from "antd";
import TSTable from "../../common/TSTable";
import ColorButton from "../../common/ColorButton";

export default function ProduceSkimLogModol(props) {
  const { target, open, onClose } = props;

  const columns = [
      { 
        title: 'เลขที่พาเลท',
        dataIndex: 'stock_no',
        key: 'stock_no',
      },
      {
        title: 'สินค้า',
        dataIndex: 'full_name',
        key: 'full_name',
        render: () => target?.product_name
      },
      {
        title: 'ชื่อย่อสินค้า',
        dataIndex: 'full_name',
        key: 'full_name',
        render: () => target?.product_short_name
      },
      {
        title: 'จำนวนทั้งหมด',
        dataIndex: 'amount',
        key: 'amount',
      },
      {
        title: 'จำนวนคงเหลือ',
        dataIndex: 'remain_amount',
        key: 'remain_amount',
      }
    ]

  return(
    <Modal
      title={"พาเลทที่เกี่ยวข้องกับล็อตผลิตสกิม"}
      destroyOnClose
      open={open}
      width={800}
      onCancel={onClose}
      footer={[
        <ColorButton onClick={onClose}>ปิด</ColorButton>
      ]}
    >
      {target && <TSTable
        title={"สต็อกสกิม"}
        columns={columns}
        size={'small'}
        data={target?.used_refs}
        hidePagination={true}
        pageSize={999}
      />}
    </Modal>
  )
    
}